module.exports = __webpack_public_path__ + "img/van.c825ee86.png";